import { createSlice } from '@reduxjs/toolkit';
import sum from 'lodash/sum';
import uniqBy from 'lodash/uniqBy';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  faqs: [],
  faq: null,
  category: null,
  other: null
};

const slice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET FAQS
    getFaqsSuccess(state, action) {
      state.isLoading = false;
      state.faqs = action.payload;
    },

    // GET FAQ
    getFaqSuccess(state, action) {
      state.isLoading = false;
      state.faq = action.payload;
    },

    // UPDATE FAQ
    updateFaqSuccess(state, action) {
      state.isLoading = false;
      state.faq = action.payload;
    },

    //  SORT & FILTER PRODUCTS
    sortByFaqs(state, action) {
      state.sortBy = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByFaqs,
} = slice.actions;

// ----------------------------------------------------------------------

export function getFaqs() {
  return async () => {
    dispatch(slice.actions.startLoading());
    let token = localStorage.getItem('token');
    try {
      const response = await axios.post('/faqs/manage/list', { 'token': token });
      dispatch(slice.actions.getFaqsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFaq(slug) {
  return async () => {
    dispatch(slice.actions.startLoading());
    let token = localStorage.getItem('token');
    try {
      const response = await axios.post('/faqs/manage/get_faq', { 'token': token, 'slug': slug});
      dispatch(slice.actions.getFaqSuccess(response.data.faq));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateFaq(values) {
  return async () => {
    dispatch(slice.actions.startLoading());
    let token = localStorage.getItem('token');
    try {
      const response = await axios.post('/faqs/manage/update_faq', { 'token': token, values});
      dispatch(slice.actions.updateFaqSuccess(response.data.faq));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

